import { getPorts } from "@velizhanin-dev/bot-scenario"
import type { DraftEdge, DraftNode } from "../api/types"

export const portKey = (nodeId: string, portId: string) => `${nodeId} ${portId}`

/** Куда ведёт каждый выход: ключ portKey → id блока. */
export function edgeTargets(edges: DraftEdge[]): Map<string, string> {
	return new Map(
		edges.map((edge) => [portKey(edge.sourceNodeId, edge.sourcePort), edge.targetNodeId]),
	)
}

/**
 * Блоки потока в порядке чтения для списка на телефоне: от старта вглубь, ветки —
 * в порядке выходов блока. Недостижимые со старта — отдельно, сверху вниз по холсту.
 */
export function orderFlowNodes(
	draft: { nodes: DraftNode[]; edges: DraftEdge[] },
	flowId: string,
): { ordered: DraftNode[]; detached: DraftNode[] } {
	const nodes = draft.nodes.filter((node) => node.flowId === flowId)
	const byId = new Map(nodes.map((node) => [node.id, node]))
	const targets = edgeTargets(draft.edges)
	const visited = new Set<string>()
	const ordered: DraftNode[] = []

	const stack = nodes.filter((node) => node.type === "start").reverse()
	while (stack.length > 0) {
		const node = stack.pop()
		if (!node || visited.has(node.id)) continue
		visited.add(node.id)
		ordered.push(node)
		const children = getPorts(node).flatMap((port) => {
			const target = byId.get(targets.get(portKey(node.id, port.id)) ?? "")
			return target && !visited.has(target.id) ? [target] : []
		})
		for (let index = children.length - 1; index >= 0; index--) stack.push(children[index])
	}

	const detached = nodes
		.filter((node) => !visited.has(node.id))
		.sort((a, b) => a.positionY - b.positionY || a.positionX - b.positionX)
	return { ordered, detached }
}
